import React from 'react';
import dateUtility from 'common/DateUtility';

import {
    InvoiceRow,
    HorizontalDivider,
    ThankYouSection,   
    InvoiceChargeEntry,
    ServiceNotesSection,
    SkylineHeader,
    PetroffHeader
} from './InvoiceCommon';

import { PaymentTypes } from 'common/constants';

const localStyles = {
    chargeEntry: {
        paddingTop: "10px",
        width: "400px",
        display: "inline-block"
    },
    invoiceHeader: {
        display: "block",
        marginLeft: "30px",
        fontSize: "18px",
        paddingTop: "20px"
    },
};

export default function TowingInvoice(props) {    
    const { customer, commonStyles, invoice, isPetroff, imageSrc, petroffImageSrc} = props;
    const styles = { ...commonStyles, ...localStyles};

    const summarySection = () => {                
        const dateTowed = invoice.dateTowed ? dateUtility.dateToString(invoice.dateTowed,'M/D/YYYY') : "";                
        const hubString = isPetroff ? 'Hub' : 'Mileage';        
        const invoicePrefix = isPetroff ? '':'T';
        const invoiceNumber = invoice.number ? `${invoicePrefix}${invoice.number}` : "DRAFT";
        return  (
            <div id={'summary-section-container'} styles={styles.summarySectionContainer}>
                <HorizontalDivider/>
                <InvoiceRow leftText={'Customer'} leftEntry={customer.name} rightText={'Invoice #'} rightEntry={invoiceNumber} id={'invoiceId'}/>
                <InvoiceRow leftText={'Address'} leftEntry={customer.street}/>
                <InvoiceRow leftText={'City'} leftEntry={customer.city} rightText={'Date Towed'} rightEntry={dateTowed} id={'date-towed'}/>
                <InvoiceRow leftText={'State'} leftEntry={customer.state} rightText={'Unit #'} rightEntry={invoice.unit}/>
                <InvoiceRow leftText={'Zip'} leftEntry={customer.zipcode} rightText={'Vehicle'} rightEntry={invoice.vehicle}/>
                <InvoiceRow leftText={'Phone'} leftEntry={customer.phone} rightText={hubString} rightEntry={invoice.hub} id={'mileage'}/>
                <InvoiceRow leftText={'Tow Vehicle'} leftEntry={invoice.towVehicle} rightText={'Reference #'} rightEntry={invoice.referenceNumber}/>
                <InvoiceRow leftText={'Location'} leftEntry={invoice.location} rightText={'Company PO #'} rightEntry={invoice.companyPO}/>                
                <HorizontalDivider/>
            </div> 
        )
    }

    const TowInvoiceChargeEntry = ({text,entry}) => {        
        return (            
            <InvoiceChargeEntry text={text} entry={entry} entryStyle={styles.chargeEntry}/>
        )
    }

    const invoiceChargeNonMonetaryEntry = (text,entry) => {
        const entryId = text.split(' ').join('-').toLowerCase();
        return (            
            <div style={styles.chargeEntry}>
                <div style={styles.chargeEntryName}>{text}:</div><div id={entryId} style={styles.entryChargeText}>{entry}</div>
            </div>
        )
    }

    const chargesSection = () => {        
        const paymentDate = invoice.paymentDate ? dateUtility.dateToString(invoice.paymentDate,'M/D/YYYY') : ""; 
        
        return (
            <div style={styles.chargesSection}>                 
                {invoiceChargeNonMonetaryEntry('Payment Type',PaymentTypes[invoice.paymentType])}
                <TowInvoiceChargeEntry text={'Mileage Charges'} entry={invoice.mileageCharges}/>                
                <TowInvoiceChargeEntry text={'Time Charges'} entry={invoice.timeCharges}/>
                <TowInvoiceChargeEntry text={'Additional Charges'} entry={invoice.additionalCharges}/>
                <TowInvoiceChargeEntry text={'Credits'} entry={invoice.credits}/>
                <TowInvoiceChargeEntry text={'Posted To Receivables'} entry={invoice.postedToReceivables}/>
                {invoiceChargeNonMonetaryEntry('Payment Date',paymentDate)}
                <TowInvoiceChargeEntry text={'Invoice Total'} entry={invoice.invoiceTotal}/>                             
            </div>
        )
    }

    return (
        <div id="capture" style={styles.page}>
            {isPetroff ? PetroffHeader(petroffImageSrc) : <SkylineHeader imageSrc={imageSrc}/>}
            {summarySection()}
            <ServiceNotesSection serviceNotes={invoice.serviceNotes}/>
            <HorizontalDivider/>
            {chargesSection()}
            <ThankYouSection/>
        </div>    
    );
}



